/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionButtonsView = Backbone.View.extend({
    initialize: function(options) {
      var self = this;
      _.bindAll(this, "render");

      this.$container = $(".location-type-list");

      // Rerender on model changes
      this.model.on("change", this.render);

      // Listen for clicks and update the model accordingly
      this.$container.on("click", ".location-type-link", function(e) {
        e.preventDefault();
        self.model.set({
          currentTab: $(this).data("slug"),
          currentTabId: $(this).data("id")
        });

        // Tracks clicks on Location Type tabs (Borough, CD, City) from the "Explore Data" page
        dataLayer.push({
          event: "Location Type Tab Clicks",
          eventCategory: "Interactive Clicks",
          eventAction:
            "Location Type Tab|" +
            $(this)
              .text()
              .trim(),
          eventLabel: window.location.pathname
        });
      });
    },

    render: function() {
      // The button html is rendered on the server side, so just
      // assign the active class to the currently selected button
      $(".location-type-link", this.$container).removeClass("active");
      $(
        ".location-type-link[data-slug='" + this.model.get("currentTab") + "']",
        this.$container
      ).addClass("active");

      // If a specific location type was just selected, run through all the links on the page and append a #hash that
      // will pre-select the location type on the destination page
      var id = this.model.get("currentTabId");
      var hash = id > 0 ? "#a/a/" + id : "";

      // We want to be able to opt out of link rewrites when using the indicator selectors in the indicator windowshade.
      if (this.options.optOutOfLinkRewrite) {
        return;
      }
      $("a.subtopic-list-link").each(function() {
        // Strip any existing #hash
        var $link = $(this);
        var baseUrl = $link.attr("href").split("#")[0];

        // Append the new #hash
        $link.attr("href", baseUrl + hash);
      });
    }
  });
})(jQuery, _);
